import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { House, Users, TrendUp, ArrowsClockwise, Receipt, UserCircle, SignOut } from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/wingman/d1fb5991-0166-4fe5-968c-76f807dc50fd/attachments/118b7de0ebb34bf293c8775031b95acc_Tarsus_Dijital_WP_PP.jpg.jpeg";

const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const navItems = [
    { to: "/dashboard", icon: House, label: "Dashboard", testId: "nav-dashboard" },
    { to: "/customers", icon: Users, label: "Müşteriler", testId: "nav-customers" },
    { to: "/income", icon: TrendUp, label: "Gelirler", testId: "nav-income" },
    { to: "/recurring", icon: ArrowsClockwise, label: "Tekrarlayan Ödemeler", testId: "nav-recurring" },
  ];

  // Sabit Giderler ve Personel yönetimi sadece admin ve yönetici için
  if (user?.role === "admin" || user?.role === "yonetici") {
    navItems.push({ to: "/fixed-expenses", icon: Receipt, label: "Sabit Giderler", testId: "nav-fixed-expenses" });
    navItems.push({ to: "/users", icon: UserCircle, label: "Personel", testId: "nav-users" });
  }

  return (
    <div className="flex min-h-screen bg-[hsl(var(--background))]">
      <aside className="w-72 bg-[hsl(var(--surface-elevated))] border-r border-[hsl(var(--border))] flex flex-col shadow-premium-sm">
        <div className="p-6 border-b border-[hsl(var(--border))]">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Tarsus Dijital"
              className="h-12 w-12 rounded-lg object-cover ring-1 ring-[hsl(var(--border))]"
              data-testid="sidebar-logo"
            />
            <div>
              <h1 className="text-xl font-bold text-[hsl(var(--text-strong))] leading-none tracking-tight">Tarsus</h1>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--text-soft))] mt-1.5 font-medium">Dijital Reklam</p>
            </div>
          </div>
        </div>
        
        <nav className="flex-1 p-4 space-y-1" data-testid="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg ${
                  isActive
                    ? "bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] shadow-premium-sm"
                    : "text-[hsl(var(--text-soft))] hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--text-strong))]"
                }`
              }
            >
              <item.icon size={18} weight="duotone" />
              <span className="text-sm font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-[hsl(var(--border))]">
          <div className="mb-3 px-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--text-faint))] mb-1 font-medium">Hesap</p>
            <p className="text-sm font-medium text-[hsl(var(--text-strong))] truncate">{user?.name || user?.email}</p>
            {user?.role && (
              <span className="inline-block mt-1.5 px-2 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-[hsl(var(--secondary))] text-[hsl(var(--text-soft))] border border-[hsl(var(--border))]">
                {user.role === "admin" ? "Admin" : user.role === "yonetici" ? "Yönetici" : "Personel"}
              </span>
            )}
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-[hsl(var(--border))] bg-transparent text-[hsl(var(--text-soft))] hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--text-strong))] hover:border-[hsl(var(--text-strong))]"
          >
            <SignOut size={16} weight="bold" />
            <span className="text-sm font-medium">Çıkış Yap</span>
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
